module.exports = __webpack_public_path__ + "static/media/logonav.341e028e.png";